import { createContext, useContext } from 'react';

interface ListFormShowContextData {
  listSource: string;
  formSource: string;
}

const EditableListFormShowContext = createContext<ListFormShowContextData>({
  listSource: '',
  formSource: '',
});
const ListFormShowContextProvider = EditableListFormShowContext.Provider;

const useListFormShowContext = () => {
  const context = useContext(EditableListFormShowContext);
  return context || {};
};
export { useListFormShowContext, ListFormShowContextProvider };
